import Vue from 'vue';
import { formatNum } from '@/util/number';

// Filter cuma kebaca kalau `|` ada di kedalaman kurung nol, jadi gak kepake di
// dalam ternary. $fmt buat ekspresi template yang begitu.
Vue.prototype.$fmt = formatNum;
